import { Optional } from '@/generic/functional';
import type { ReactNode } from 'react';

export const useOptional = <T>({
  optional,
  onValuated,
  onEmpty,
}: {
  optional: Optional<T>;
  onValuated: (value: T) => ReactNode;
  onEmpty?: () => ReactNode;
}) =>
  optional
    .map(onValuated)
    .or(() => Optional.ofFalsifiable(onEmpty).map((onEmpty) => onEmpty()))
    .orUndefined();
